"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trigger = Trigger;

var _react = _interopRequireDefault(require("react"));

var Elements = _interopRequireWildcard(require("@bueno/blocks/lib/components/DropdownMenu/DropdownMenu.styles"));

function Trigger({
  main,
  sub,
  onClick
}) {
  return /*#__PURE__*/_react.default.createElement(Elements.TriggerButton, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(Elements.FlexWrapper, null, /*#__PURE__*/_react.default.createElement(Elements.TextWrapper, null, /*#__PURE__*/_react.default.createElement(Elements.Trigger, null, main), /*#__PURE__*/_react.default.createElement(Elements.Current, null, sub)), /*#__PURE__*/_react.default.createElement(Elements.StyledArrowDropdownDown, {
    tiny: true
  })));
}